import { FC, Fragment, ReactNode } from 'react';
import { Typography } from '@mui/material';

const naValue = '-';

const Skeleton: FC = () => (
  <div style={{ width: '100%', height: '10px', background: '#f1f1f1', borderRadius: '5px' }} />
);

type ValueOrDefaultProps = {
  loading?: boolean;
  value?: ReactNode;
};

export const ValueOrDefault: FC<ValueOrDefaultProps> = ({ value, loading = false }) => {
  if (!value && loading) {
    return <Skeleton />;
  }

  if (!value) return <>{naValue}</>;

  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' ? (
    <Typography component='span' variant='inherit'>
      {value.toString()}
    </Typography>
  ) : (
    <Fragment>{value}</Fragment>
  );
};
